import { watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useChoresStore } from '@/stores/chores'
import { useRewardsStore } from '@/stores/rewards'
import { useLogger } from '@/composables/useLogger'

export function useShellCounts(): void {
  const authStore = useAuthStore()
  const chores = useChoresStore()
  const rewards = useRewardsStore()
  const { logger } = useLogger()

  watch(
    [() => authStore.accountId, () => authStore.isAdult],
    async ([accountId, isAdult]) => {
      if (!accountId) return

      try {
        if (isAdult) {
          await chores.fetchPendingReviews({ background: true })
        } else {
          await rewards.fetchPointBalance()
        }
      } catch (error) {
        logger.warn('Failed to refresh shell counts', { accountId, isAdult, error })
      }
    },
    { immediate: true },
  )
}
